import storage from '@/storage/index.js';
import router from '@/router';
import { getSubjectInfo } from '@/utils/jsbridge/webEntrance';
import { RECENTTYPE } from '@/storage/recently.js';
import { useRecently } from 'platform-lib-app';
import Vconsole from 'vconsole';

export function initApp(app) {
  // storage存储，是否第一次使用
  storage.setFirstLogin(storage.getFirstLogin());
  // storage.setHomeChartEye(storage.getHomeChartEye());
  // router 跳转&缓存页面
  router.keepAlivePush = (routeLocationRaw) => {
    router.push({
      ...routeLocationRaw,
    });
  };
  getSubjectInfo().then(res => {
    if (import.meta.env.VITE_APP_ENV !== 'prod' && res?.loginuser?.mobile && res?.loginuser?.mobile !== '+8613444449999' && res?.loginuser?.mobile !== '+8613555559999' && res?.loginuser?.mobile !== '+8613444444444') {
      new Vconsole();
    }
  });

  const recently = useRecently();
  recently.initRecentlyList(RECENTTYPE);
}
